import { Filter } from "remult";

export function createCustomFilterForEntity<EntityType>() {
  function customFilter(
    arg: Parameters<typeof Filter.createCustom<EntityType>>[0],
  ): ReturnType<typeof Filter.createCustom<EntityType>>;
  function customFilter<Params>(
    arg: Parameters<typeof Filter.createCustom<EntityType, Params>>[0],
  ): ReturnType<typeof Filter.createCustom<EntityType, Params>>;
  function customFilter<Params = never>(
    arg:
      | Parameters<typeof Filter.createCustom<EntityType, Params>>[0]
      | Parameters<typeof Filter.createCustom<EntityType>>[0],
  ) {
    return Filter.createCustom(arg);
  }

  return customFilter;
}
